import React from "react"

import styles from "./styles.module.scss"
import SearchBar from "components/SearchBar"

const StandardFilter = ({ className, filters, setFilters, csvData }) => {

  // Layout

  let classes = styles.standardFilter
  if (className) classes = `${classes} ${className}`
  
  return (
    <>
      <div className={classes}>
        <div className={styles.standardFilter__left}>
          <SearchBar placeholder="Enter Power Number to filter" value={filters?.search || ''} onChange={e => setFilters(f => { return { ...f, search: e.target.value } })} />
          {/* <Select
            id="dateType"
            defaultValue={filters?.dateType || 'PAYMENT_DATE'}
            style={{ width: 140 }}
            options={[
              { value: 'PAYMENT_DATE', label: 'Payment Date' },
              { value: 'DEPOSIT_DATE', label: 'Deposit Date' }
            ]}
            onChange={val => setFilters('dateType', val)}
          />
          <RangePicker defaultValue={filters?.dates || []} onChange={(val) => setFilters('dates', val)} /> */}
        </div>
        <div className={styles.standardFilter__right}>
          {/* {_getCsvExport()}  */}
          &nbsp;
        </div>
      </div>
    </>
  )
}

export default StandardFilter
